<template>
  <div>
    <!--banner区域-->
    <img class="banner" src="../../assets/img/extend/chrome_banner.png" alt />
    <div class="banner_container">
      <div class="banner_box">
        <div class="banner_content">
          <div class="banner_header">小易插件助手</div>
          <div class="banner_des">
            <p>1、一键导入各大招聘网站的求职者信息，省去一系列繁琐的操作；</p>
            <p>2、快速查找、购买第三方渠道的简历并同步至系统，方便快捷；</p>
            <p>3、目前支持的网站包括BOSS直聘、拉勾、猎聘、前程无忧、智联招聘、58同城、智通人才网、卓博人才网、最佳东方网、实习僧、大街网、重庆人才网、广西人才招聘网、滕州人才网、广西人才网、广西毕业生招聘网、新安人才网、114人才招聘网、厦门人才网、泉州人才网；</p>
            <p>4、支持的浏览器分别是：</p>
          </div>
          <div class="extend_flate">
            <div class="safeWrapper" @click="goSafe('chrome')">
              <div class="extend_flate_item">
                <div class="safeBox">
                  <img src="../../assets/img/extend/chrome.png" />
                  <span>Chrome浏览器</span>
                </div>
              </div>
              <div class="text">Windows/Mac版</div>
            </div>
            <div class="safeWrapper" @click="goSafe('360')">
              <div class="extend_flate_item">
                <div class="safeBox">
                  <img src="../../assets/img/extend/360fast.png" />
                  <span>360极速浏览器</span>
                </div>
              </div>
              <div class="text">Windows/Mac版</div>
            </div>
            <!-- <div class="safeWrapper" @click="goSafe('sogu')">
              <div class="extend_flate_item">
                <div class="safeBox">
                  <img src="../../assets/img/extend/sogosafe.png" />
                  <span>搜狗浏览器</span>
                </div>
              </div>
              <div class="text">Windows版</div>
            </div> -->
            <div class="safeWrapper" @click="goSafe('qq')">
              <div class="extend_flate_item">
                <div class="safeBox">
                  <img src="../../assets/img/extend/qqsafe.png" />
                  <span>QQ浏览器</span>
                </div>
              </div>
              <div class="text">Windows版</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--内容区域-->
    <div class="introduce">
      <div class="introduce_box">
        <!-- <div class="introduce_left">
          <div class="panel">
            <div class="panel_header">快捷操作</div>
            <div class="panel_content">
              <div class="title1">第一步：下载插件</div>
              <a
                href="https://a.hire66.com/download/yzp/"
                download="https://a.hire66.com/download/yzp/"
                class="download_btn"
              >
                <div class="download_btn">下载插件</div>
              </a>
              <div class="line"></div>
              <div class="title1">第二步：安装插件</div>
              <div class="title2">复制下列链接到浏览器，快速进入安装页面</div>
              <div class="chrome_wrap">
                <div class="flex_between mt20">
                  <div class="name">Chrome浏览器</div>
                  <div class="copy" data-clipboard-text="chrome://extensions">
                    <span style="margin-right:5px">复制</span>
                    <i class="el-icon-tickets"></i>
                  </div>
                </div>
                <div class="link">chrome://extensions</div>
              </div>
              <div class="chrome_wrap">
                <div class="flex_between mt20">
                  <div class="name">360极速浏览器</div>
                  <div class="copy" data-clipboard-text="chrome://myextensions/extensions">
                    <span style="margin-right:5px">复制</span>
                    <i class="el-icon-tickets"></i>
                  </div>
                </div>
                <div class="link">chrome://myextensions/extensions</div>
              </div>
              <div class="chrome_wrap">
                <div class="flex_between mt20">
                  <div class="name">搜狗浏览器</div>
                  <div
                    class="copy"
                    data-clipboard-text="se://settings/?category=extension&type=extensionbar"
                  >
                    <span style="margin-right:5px">复制</span>
                    <i class="el-icon-tickets"></i>
                  </div>
                </div>
                <div class="link">se://settings/?category=extension&type=extensionbar</div>
              </div>
              <div class="chrome_wrap">
                <div class="flex_between mt20">
                  <div class="name">QQ浏览器</div>
                  <div class="copy" data-clipboard-text="qqbrowser://extensions/manage">
                    <span style="margin-right:5px">复制</span>
                    <i class="el-icon-tickets"></i>
                  </div>
                </div>
                <div class="link">qqbrowser://extensions/manage</div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="introduce_right">
          <div class="panel">
            <div class="panel_header flex_between">浏览器插件安装教程</div>
            <div class="browserWrap">
              <div
                class="browser"
                :class="system==='chrome'?'active':''"
                @click="changeSystem('chrome')"
              >
                <span>Chrome浏览器</span>
                <span class="arrow arrow_left"></span>
                <span class="arrow arrow_right"></span>
                <span></span>
              </div>
              <div
                class="browser"
                :class="system==='360fast'?'active':''"
                @click="changeSystem('360fast')"
              >
                <span class="arrow arrow_left"></span>
                <span class="arrow arrow_right"></span>
                <span>360极速浏览器</span>
              </div>
              <div
                class="browser"
                :class="system==='qqCourse'?'active':''"
                @click="changeSystem('qqCourse')"
              >
                <span>QQ浏览器</span>
                <span class="arrow arrow_left"></span>
                <span class="arrow arrow_right"></span>
              </div>
            </div>
            <div class="systemWrap flex_start mt20">
              <div
                class="system"
                @click="changeTab('window')"
                :class="current =='window' ? 'current':''"
              > 
                Windows版 
                <div class="system_line"></div>
              </div>
              <div
                v-if="system==='chrome' || system==='360fast'"
                class="system"
                :class="current =='mac' ? 'current':''"
                @click="changeTab('mac')"
              >
                Mac版
                <div class="system_line"></div>
              </div>
            </div>
          </div>
          <div class="panel">
            <!--chrome浏览器教程-->
            <div class="extend_tabs" v-if="system==='chrome'">
              <div class="extend_tabs_mac">
                <div class="extend_bowser">
                  <div class="extend_title" style="margin-top: 10px">
                     <span class="signal">1</span>
                    <p>下载插件</p>
                      <a
                        href="https://a.hire66.com/download/yzp/"
                        download="https://a.hire66.com/download/yzp/"
                      >
                        <div class="download_btn">
                          <div class="down_btn" >
                            <img src="../../assets/img/download_icon.png" alt=""> 点击下载
                          </div>
                        </div>
                    </a>

                  </div>
                  <div class="extend_content">下载插件压缩包，选择插件安装路径</div>
                  <img v-if="system==='chrome' && current === 'window'" class="extend_pic" src="../../assets/step/chrome_window_1.png" alt="">
                  <img v-if="system==='chrome' && current === 'mac'" class="extend_pic" src="../../assets/step/chrome_mac_1.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">2</span>
                    <p>解压下载的文件</p>
                  </div>
                  <div class="extend_content">选中文件夹，鼠标{{ current === 'mac' ? '双' : '右' }}击，将下载好的文件，进行解压</div>
                  <img v-if="system==='chrome' && current === 'window'" class="extend_pic" src="../../assets/step/chrome_window_2.png" alt="">
                  <img v-if="system==='chrome' && current === 'mac'" class="extend_pic" src="../../assets/step/chrome_mac_2.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">3</span>
                    <p>打开扩展程序</p>
                  </div>
                  <div class="extend_content">
                    复制链接（ <span style="color: rgba(76,89,107,.8)">chrome://extensions </span> 
                      <img
                        id="tag-copy"
                        data-clipboard-text="chrome://extensions"
                        style="width:13px; height: 15px;vertical-align: middle;margin:0 5px" 
                        src="../../assets/img/copy.png" 
                        alt=""
                        @click="copyActiveCode($event,'chrome://extensions')"
                      >）粘贴到地址栏，按回车键，在浏览器中打开可快速进入插件安装页面
                  </div>
                  <img v-if="system==='chrome' && current === 'window'" class="extend_pic" src="../../assets/step/chrome_window_3.png" alt="">
                  <img v-if="system==='chrome' && current === 'window'" class="extend_pic" src="../../assets/step/chrome_window_4.png" alt="">
                  <img v-if="system==='chrome' && current === 'mac'" class="extend_pic" src="../../assets/step/chrome_01.gif" alt="">
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'window'">
                  <div class="extend_title">
                    <span class="signal">4</span>
                    <p>完成安装</p>
                  </div>
                  <div class="extend_content">方式一：将解压好的yzp文件夹拖入【加载已解压的扩展程序】，完成安装</div>
                  <img class="extend_pic" src="../../assets/step/chrome_window_5.png" alt="">
                  <div class="extend_content">方式二：鼠标点击【加载已解压的扩展程序】，在“选择扩展程序目录”弹窗选择yzp文件夹，完成安装</div>
                  <img class="extend_pic" src="../../assets/step/chrome_window_6.png" alt="">
                  <img class="extend_pic" src="../../assets/step/chrome_window_7.png" alt="">
                </div>
                 <div class="extend_bowser" v-if="system==='chrome' && current === 'mac'">
                  <div class="extend_title">
                    <span class="signal">4</span>
                    <p>打开开发者模式</p>
                  </div>
                  <div class="extend_content">在扩展程序页面打开右上角的【开发者模式】按钮</div>
                  <img class="extend_pic" src="../../assets/step/chrome_02.gif" alt=""> 
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'window'">
                  <div class="extend_title">
                    <span class="signal">5</span>
                    <p>扫码绑定</p>
                  </div>
                  <div class="extend_content"> 安装完成后，使用 <span style="color: #2782FE">手机钉钉 -【扫一扫】</span> 扫码绑定</div>
                  <img class="extend_pic" src="../../assets/step/chrome_window_8.png" alt="">
                  <img class="extend_pic" src="../../assets/step/chrome_window_9.png" alt="">
                  <img class="extend_pic" src="../../assets/step/chrome_window_10.png" alt="">
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'mac'">
                  <div class="extend_title">
                    <span class="signal">5</span>
                    <p>安装插件</p>
                  </div>
                  <div class="extend_content">将解压后的整个文件夹拖拽至“扩展程序”页面中，安装成功</div>
                  <img class="extend_pic" src="../../assets/step/chrome_03.gif" alt=""> 
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'window'">
                  <div class="extend_title">
                    <span class="signal">6</span>
                    <p>设置默认浏览器</p>
                  </div>
                  <div class="extend_content">将安装插件的浏览器设置为默认浏览器</div>
                  <img class="extend_pic" src="../../assets/step/chrome_window_11.png" alt=""> 
                  <img class="extend_pic" src="../../assets/step/chrome_window_12.png" alt=""> 
                  <img class="extend_pic" src="../../assets/step/chrome_window_13.png" alt=""> 
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'mac'">
                  <div class="extend_title">
                    <span class="signal">6</span>
                    <p>扫码绑定</p>
                  </div>
                  <div class="extend_content">
                    安装完成后，使用 <span style="color: #2782FE">手机钉钉 -【扫一扫】</span> 扫码绑定
                  </div>
                  <img class="extend_pic" src="../../assets/step/chrome_mac_4.png" alt=""> 
                  <img class="extend_pic" src="../../assets/step/chrome_mac_5.png" alt=""> 
                  <img class="extend_pic" src="../../assets/step/chrome_mac_6.png" alt=""> 
                </div>
                <div class="extend_bowser" v-if="system==='chrome' && current === 'mac'">
                  <div class="extend_title">
                    <span class="signal">7</span>
                    <p>设置默认浏览器</p>
                  </div>
                  <div class="extend_content">将安装插件的浏览器设置为默认浏览器</div>
                  <img class="extend_pic" src="../../assets/step/chrome_04.gif" alt=""> 
                </div>
                <div class="extend_bowser" style="margin-bottom: 70px;">
                  <div class="extend_title">
                    <span class="signal">{{ current === 'mac' ? '8' : '7' }}</span>
                    <p>完成</p>
                  </div>
                </div>
              </div>
              <div class="extend_tabs_window"></div>
            </div>
            <!--360极速浏览器教程-->
            <div class="extend_tabs" v-if="system==='360fast'">
              <div class="extend_tabs_mac">
                <div class="extend_bowser">
                  <div class="extend_title" style="margin-top: 10px;">
                    <span class="signal">1</span>
                    <p>下载插件</p>
                    <a
                        href="https://a.hire66.com/download/yzp/"
                        download="https://a.hire66.com/download/yzp/"
                        class="download_btn"
                      >
                        <div class="down_btn">
                          <img src="../../assets/img/download_icon.png" alt=""> 点击下载
                        </div>
                    </a>
                  </div>
                  <div class="extend_content">下载插件压缩包，选择插件安装路径</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_1.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_1.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">2</span>
                    <p>解压下载的文件</p>
                  </div>
                  <div class="extend_content">选中文件夹，鼠标{{ current === 'mac' ? '双' : '右' }}击，将下载好的文件，进行解压</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_2.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_2.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">3</span>
                    <p>打开扩展程序</p>
                  </div>
                  <div class="extend_content">复制链接（ <span style="color: rgba(76,89,107,.8)">chrome://myextensions/extensions </span> 
                    <img
                      id="tag-copy"
                      data-clipboard-text="chrome://myextensions/extensions"
                      style="width:13px; height: 15px;vertical-align: middle;margin:0 5px;" 
                      src="../../assets/img/copy.png" 
                      alt=""
                      @click="copyActiveCode($event,'chrome://myextensions/extensions')"
                    >）粘贴到地址栏，按回车键，在浏览器中打开可快速进入插件安装页面</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_3.png" alt="">
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_4.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_3.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_4.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">4</span>
                    <p>完成安装</p>
                  </div>
                  <div class="extend_content">方式一：将解压好的yzp文件夹拖入【加载已解压的扩展程序】，完成安装</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_5.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_5.png" alt="">
                  <div class="extend_content">方式二：鼠标点击【加载已解压的扩展程序】，在“选择扩展程序目录”弹窗选择yzp文件夹，完成安装</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_6.png" alt="">
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_7.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_6.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_7.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">5</span>
                    <p>扫码绑定</p>
                  </div>
                  <div class="extend_content"> 安装完成后，使用 <span style="color: #2782FE">手机钉钉 -【扫一扫】</span> 扫码绑定</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_8.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_8.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">6</span>
                    <p>设置成默认浏览器</p>
                  </div>
                  <div class="extend_content">将安装插件的浏览器设置为默认浏览器</div>
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_9.png" alt="">
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_10.png" alt="">
                  <img v-if="system==='360fast' && current === 'window'" class="extend_pic" src="../../assets/step/360_window_11.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_9.png" alt="">
                  <img v-if="system==='360fast' && current === 'mac'" class="extend_pic" src="../../assets/step/360_mac_10.png" alt="">
                </div>
                <div class="extend_bowser" style="margin-bottom: 70px;">
                  <div class="extend_title">
                    <span class="signal">7</span>
                    <p>完成</p>
                  </div>
                </div>
              </div>
              <div class="extend_tabs_window"></div>
            </div>
            <!-- qq浏览器教程-->
            <div class="extend_tabs" v-if="system==='qqCourse'">
              <div class="extend_tabs_mac">
                <div class="extend_bowser">
                  <div class="extend_title" style="margin-top: 10px;">
                    <span class="signal">1</span>
                    <p>下载插件</p>
                    <a
                        href="https://a.hire66.com/download/yzp/"
                        download="https://a.hire66.com/download/yzp/"
                        class="download_btn"
                      >
                        <div class="down_btn">
                          <img src="../../assets/img/download_icon.png" alt=""> 点击下载
                        </div>
                    </a>
                  </div>
                  <div class="extend_content">下载插件压缩包，选择插件安装路径</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_1.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">2</span>
                    <p>解压下载的文件</p>
                  </div>
                  <div class="extend_content">选中文件夹，鼠标右击，将下载好的文件，进行解压</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_2.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">3</span>
                    <p>打开扩展程序</p>
                  </div>
                  <div class="extend_content">复制链接（ <span style="color: rgba(76,89,107,.8)">qqbrowser://extensions/manage </span> 
                     <img
                      id="tag-copy"
                      data-clipboard-text="qqbrowser://extensions/manage"
                      style="width:13px; height: 15px;vertical-align: middle;margin: 0 5px;" 
                      src="../../assets/img/copy.png" 
                      alt=""
                      @click="copyActiveCode($event,'qqbrowser://extensions/manage ')"
                    >）粘贴到地址栏，按回车键，在浏览器中打开可快速进入插件安装页面</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_3.png" alt="">
                  <img class="extend_pic" src="../../assets/step/qq_window_4.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">4</span>
                    <p>完成安装</p>
                  </div>
                  <div class="extend_content">方式一：将解压好的yzp文件夹拖入【加载已解压的扩展程序】，完成安装</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_5.png" alt="">
                  <div class="extend_content">方式二：鼠标点击【加载已解压的扩展程序】，在“选择扩展程序目录”弹窗选择yzp文件夹，完成安装</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_6.png" alt="">
                  <img class="extend_pic" src="../../assets/step/qq_window_7.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">5</span>
                    <p>扫码绑定</p>
                  </div>
                  <div class="extend_content"> 安装完成后，使用 <span style="color: #2782FE">手机钉钉 -【扫一扫】</span> 扫码绑定</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_8.png" alt="">
                </div>
                <div class="extend_bowser">
                  <div class="extend_title">
                    <span class="signal">6</span>
                    <p>设置成默认浏览器</p>
                  </div>
                  <div class="extend_content">将安装插件的浏览器设置为默认浏览器</div>
                  <img class="extend_pic" src="../../assets/step/qq_window_9.png" alt="">
                  <img class="extend_pic" src="../../assets/step/qq_window_10.png" alt="">
                </div>
                <div class="extend_bowser" style="margin-bottom: 70px;">
                  <div class="extend_title">
                    <span class="signal">7</span>
                    <p>完成</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--安装插件提醒-->
    <el-dialog
      title="安装插件提醒"
      :visible.sync="dialogVisible"
      width="25%"
      :show-close="false"
      :before-close="handleClose"
    >
      <span>检测到该浏览器未安装插件，请安装后再发布岗位！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";
export default {
  components: {},
  data() {
    return {
      text: "",
      url: "",
      system: "chrome", // 操作系统'chrome'，'360fast'，'sogou','qqCourse'
      current: "mac",
      other: "360win",
      dialogVisible: false,
      timer: "",
      id:"111",
    };
  },
  methods: {
    copyActiveCode() {
      const clipboard = new ClipboardJS("#tag-copy")
      clipboard.on('success', e => {
        this.$message({ type: 'success', message: '复制成功' })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({ type: 'waning', message: '该浏览器不支持自动复制' })
        // 释放内存
        clipboard.destroy()
      })
    },
    // 前往下载
    goSafe(val) {
      switch (val) {
        case "chrome":
          window.open("https://www.google.cn/chrome/", "_blank");
          break;
        case "360":
          window.open("https://browser.360.cn/ee/", "_blank");
          break;
        case "sogu":
          window.open("https://ie.sogou.com/", "_blank");
          break;
        case "qq":
          window.open("https://browser.qq.com/?adtag=SEM170314031", "_blank");
          break;
      }
    },
    handleDownload() {
      console.log("https://a.hire66.com/download/yzp//")
      window.location.href = "https://a.hire66.com/download/yzp/";
    },
    // 关闭弹窗
    handleClose() {
      let timer = this.timer;
      clearInterval(timer);
      this.dialogVisible = false;
    },
    // 关闭弹窗
    closeDialog() {
      let timer = this.timer;
      clearInterval(timer);
      this.dialogVisible = false;
    },
    // 判断岗位id是否存在
    isTag() {
      let position_id = this.getUrlKey("position_id");
      let channel_id = this.getUrlKey("channel_id");
      let operator_id = this.getUrlKey("operator_id");
      //通过接口获取企业插件id
      var xhr = new XMLHttpRequest();
      let base_url_new = "https://a.hire66.com/";
      xhr.open(
        "GET",
        `${base_url_new}apiweb/position/getExtendId?operator_id=${operator_id}`,
        false
      );
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.onreadystatechange = () => {
        if (xhr.readyState && xhr.status == 200) {
          console.log(xhr.responseText);
          if (xhr.responseText) {
            let data = JSON.parse(xhr.responseText);
            if (data.status_code == 200) {
              this.id = data.data;
            }
          }
        }
      };
      xhr.send();
      //兼容老插件问题
      setTimeout(() => {
        try {
          console.log("检查有无插件")
          window.chrome.runtime.sendMessage(
            this.id,
            {
              type: "POSITION_SAVE_PBULIC_TRANSLATE",
              pubilcData: {
                position_id: position_id,
                channel_id: channel_id,
                fromData: {}
              }
            },
            (e)=> {
              console.log(e, "success response");
              if(e.status == "success"){
                this.dialogVisible = false;
                this.is_chrome(position_id, channel_id);
              }else{
                console.log("弹出没有插件的弹框");
                this.dialogVisible = true;
              }
            });         
        } catch (error) {
          console.log("弹出没有插件的弹框");
          this.dialogVisible = true;
        }
      }, 500);
    },
    // 获取跳转的url
    getJumpUrl(channel_id) {
      let channel_json = [
        {
          id: 2,
          url:
            // "https://www.zhipin.com/web/boss/job/edit?encryptId=0"
            "https://www.zhipin.com/web/chat/job/edit?encryptId=0"
        },
        {
          id: 3,
          url: "https://easy.lagou.com/position/multiChannel/createPosition.htm"
        }
      ];
      return channel_json.find(item => item.id == channel_id).url;
    },
    // 判断是否是chrome
    is_chrome(position_id, channel_id) {
      let channel_json = [
         {
          id: 1,
          url:
            // "https://www.zhipin.com/web/boss/job/edit?encryptId=0"
            "https://www.zhipin.com/web/chat/job/edit?encryptId=0"
        },
        {
          id: 2,
          url: "https://lpt.liepin.com/ejobedit/editsocietyejob"
        },
        {
          id: 3,
          url: "https://easy.lagou.com/position/multiChannel/createPosition.htm"
        },
        {
          id: 5,
          url: "https://rd5.zhaopin.com/job/publish"
        },
        {
          id: 4,
          url: "https://ehire.51job.com/Jobs/JobEdit.aspx?Mark=New"
        },
        {
          id: 7,
          url: "https://zppost.58.com/zhaopin/1/9224/j5"
        },
        {
          id: 9, // 大街网
          url: "https://job.dajie.com/recruit/create?from=left_nav"
        },
        {
          id: 12,
          url: "http://hr.job5156.com/position/add"
        },
        {
          id: 13,
          url: "https://hire.jobcn.com/company/companyJob/pubPos.xhtml"
        },
        {
          id:14,
          url:"https://vip.veryeast.cn/job/add"
        },
        {
          id:15,
          url:"https://hr.shixiseng.com/job-management/internship/publish-job"
        },
        {
          id:16, // 汇博人才网
          url:"https://company.huibo.com/job/add/" 
        },
        {
          id:17, // 广西人才网
          url:"http://www.gxrcw.com/company/com_job_publish.aspx" 
        },
        {
          id:18, // 滕州人才网
          url:"http://www.tzjob.com.cn/ent/publishjob.asp?action=add" 
        },
        {
          id:19, // 广西毕业生就业网
          url:"https://www.gxbys.com/user/company/company_jobs.php?act=addjobs"
        },
        {
          id:20, // 广西人才网
          url:"https://vip.gxrc.com/Position/PositionEdit"
        },
        {
          id:21, // 新安人才网
          url:"https://ehr.goodjobs.cn/dispatcher.php/module/Job/action/EditJob"
        },
        {
          id:22, // 114人才招聘网
          url:"https://hn.118114zhaopin.com/company/jobs_add.html"
        },
        {
          id:28, // 康强网
          url:"https://c.kq36.com/newadmin/editjob.asp"
        }
      ];
      const formData = {
        jobName: "",
        jobDesc: "",
        job_description_notags: "",
        department: "",
        job_highlights: "",
        hireType: "",
        hireTypeText: "",
        workAge: "",
        workAgeText: "",
        eduGrade: "",
        eduGradeText: "",
        minSalary: "",
        maxSalary: "",
        hireNum: ""
      };
      let chrome = window.chrome;
      let jumpUrl = channel_json.find(item => item.id == channel_id).url;
      console.log("跳转链接"+jumpUrl)
      setInterval(() => {
        let base_url = "https://a.hire66.com/";
        let id = this.id;
        if (id) {
          var xhr = new XMLHttpRequest();
          xhr.open(
            "GET",
            `${base_url}apiweb/position/extendPositionDetail?position_id=${position_id}`,
            false
          );
          xhr.setRequestHeader("Content-type", "application/json");
          xhr.onreadystatechange = function(){
            if (xhr.readyState && xhr.status == 200) {
              if (xhr.responseText) {
                let data = JSON.parse(xhr.responseText);
                if (data.status_code == 200) {
                  let {
                    name,
                    department_name,
                    education_req,
                    job_description,
                    job_highlights,
                    salary_range,
                    work_num,
                    job_description_notags,
                    recruitment_count,
                    work_type
                  } = data.data;
                  salary_range = salary_range
                    ? salary_range.replace(/[K|k]/g, "000")
                    : "";
                  formData.jobName = name ? name : "";
                  formData.jobDesc = job_description ? job_description : "";
                  formData.department = department_name? department_name : "";
                  formData.job_highlights = job_highlights? job_highlights: "";
                  formData.eduGradeText = education_req ? education_req : "";
                  formData.minSalary = salary_range? salary_range.split("-")[0] - 0: "";
                  formData.maxSalary = salary_range? salary_range.split("-")[1] - 0: "";
                  formData.hireNum = recruitment_count;
                  formData.workAgeText = work_num? work_num.replace(/~/g, "-"): "";
                  formData.job_description_notags = job_description_notags;
                  formData.hireType = work_type;
                  console.log(formData)
                  chrome.runtime.sendMessage(
                    id,
                    {
                      type: "POSITION_SAVE_PBULIC_DATA",
                      pubilcData: {
                        position_id: position_id,
                        channel_id: channel_id,
                        fromData: formData
                      }
                    },
                    function(e) {
                      console.log(e, "POSITION_SAVE_PBULIC_DATA response");
                      // if (e.status == "success") {
                      window.location.href = jumpUrl;
                      return;
                      // }
                    }
                  );
                }
              }
            }
          };
          xhr.send();
        }else {
          console.log("暂无插件");
        } 
      }, 500);
    },
    // 获取页面参数
    getUrlParams(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
      var r = this.props.location.search.substr(1).match(reg);
      console.log(window.location.href.split("?")[1]);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 获取url参数
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            window.location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    // 切换系统类型
    changeTab(val) {
      this.current = val;
    },
    // 切换浏览器类型
    changeSystem(val) {
      this.system = val;
      if (val === "qqCourse" || val === "sogou") {
        this.current = "window";
      }
    }
  },
  mounted() {
    this.isTag();
    let _this = this;
    let clipboard = new ClipboardJS(".copy");
    clipboard.on("success", function(e) {
      _this.$message({
        message: "复制成功",
        type: "success"
      });
    });
  }
};
</script>

<style scoped lang="scss">
.flex_start {
  display: flex;
  align-items: center;
}
.flex_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mt30 {
  margin-top: 30px;
}
.mt20 {
  margin-top: 20px;
}
.textBlue {
  /*color: #0c7bd7;*/
  font-style: normal;
}
.download_btn {
  width: 97px;
  height: 26px;
  background: #11D499;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  line-height: 26px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0px 2px 3px 0px rgba(2,124,227,0.3);
  border-radius: 4px;
  margin-left: 26px;
  img {
    width: 13px;
    height: 13px;
    vertical-align: middle;
    margin-right: 3px;
  }
}
.banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 480px;
  z-index: -1;
}
.banner_container {
  min-width: 1200px;
  background-color: rgba(0, 7, 18, 0.7);
}
.banner_box {
  color: #fff;
  min-width: 1200px;
  // width: 1460px;
  margin: 0 auto;
  .banner_content {
    margin: 0 20%;
    // margin-left: 320px;
    padding-top: 60px;
    padding-bottom: 70px;
    .banner_header {
      font-size: 30px;
      font-weight: 500;
      line-height: 40px;
    }
    .banner_des {
      margin-top: 26px;
      font-size: 14px;
      font-weight: lighter;
    }
  }
}
.extend_flate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  margin-top: 30px;
  .safeWrapper {
    margin-right: 10px;
    .extend_flate_item {
      padding: 17px 20px;
      box-sizing: border-box;
      width: 200px;
      height: 60px;
      background: #f8f8fb;
      border-radius: 6px;
      border: 1px solid #d1d1d6;
      display: flex;
      justify-content: center;
      align-content: center;
      cursor: pointer;
      &:hover {
        color: #0c86dc;
        background: #fff;
        border-color: #0c86dc;
        box-shadow: 0px 2px 10px 0px rgba(209, 209, 214, 0.5);
        .safeBox span {
          color: #0c86dc;
        }
      }
      .safeBox {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin-right: 10px;
        }
        span {
          height: 25px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 25px;
          display: block;
        }
      }
    }
    .text {
      text-align: center;
      margin-top: 6px;
      line-height: 24px;
      font-size: 14px;
      font-weight: lighter;
    }
  }
}

.introduce {
  background-color: #f6f6f6;
  padding-top: 20px;
}
.introduce_box {
  min-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.introduce_left {
  width: 300px;
}
.introduce_right {
  width: 1200px;
  margin-bottom: 100px;
}
.panel {
  width: 100%;
  background: #ffffff;
  padding: 30px;
  .panel_header {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    color: #333;
    padding-bottom: 30px;
  }
  .line {
    width: 240px;
    height: 6px;
    background: #f5f7f9;
    margin-top: 30px;
  }
  .title1 {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    color: #008bff;
    line-height: 30px;
    margin-top: 30px;
  }
  .title2 {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #8e8e93;
    line-height: 20px;
    letter-spacing: 0px;
    width: 90%;
    margin: 0 auto;
  }
  .name {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
  }
  .copy {
    font-size: 14px;
    font-weight: 400;
    color: #008bff;
    line-height: 20px;
    letter-spacing: 0px;
    cursor: pointer;
  }
  .link {
    font-size: 14px;
    font-weight: 400;
    color: #33302d;
    line-height: 20px;
    letter-spacing: 0px;
    margin-top: 4px;
  }
  .browserWrap {
    display: flex;
    width: 100%;
    background-color: #F4F9FF;
    border-radius: 8px;
    height: 78px;
    padding: 7px 0 0 8px;
    overflow: hidden;
  }
  .browser {
    width: 200px;
    height: 71px;
    line-height: 71px;
    background: #F4F9FF;
    text-align: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-right: 8px;
    cursor: pointer;
    font-size: 16px;
    position: relative;
    color: #858EA6; 
    .arrow {
      position: absolute;
      width: 8px;
      height: 8px;
      transform: rotate(45deg);
      background-color: #fff;
      display: none;
      &_right {
        bottom: -4px;
        right: -3px;
      }
      &_left {
        bottom: -4px;
        left: -3px;
      }
    }
    &.active {
      color: #2782FE;
      background-color: #fff;
      box-shadow: 0 2px 10px 0px rgba(12, 123, 215, 0.1);
      .arrow {
        display: inline-block;
      }
    }
  }
}
.systemWrap {
  border-bottom: 1px solid #EBF0F6;
  padding-bottom: 7px;
  .system {
    width: 120px;
    height: 30px;
    color: #4C596B;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    line-height: 30px;
    letter-spacing: 0px;
    cursor: pointer;
    margin-right: 10px;
    &_line {
      width: 26px;
      height: 2px;
      background-color: #2782FE;
      border-radius: 1px;
      margin: 7px auto;
      display: none;
    }
    &:hover {
      opacity: 0.8;
    }
    &.current {
      color: #2782FE;
      .system_line {
        display: block;
      }
    }
  }
}

.extend_tabs {
  width: 100%;
  .extend_bowser {
    margin-bottom: 14px;
    .signal {
      display: block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #fff;
      background: #2782FE;
      border-radius: 7px 7px 7px 0px;
      margin-right: 8px;
    }
    p {
      height: 30px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 48, 45, 1);
      line-height: 30px;
      margin: 0 !important;
      padding: 0 !important;
      .down_btn {

      }

    }
    .extend_title {
      display: flex;
      align-items: center;
      margin-top: 120px;
    }
    .extend_content {
      font-size: 15px;
      line-height: 30px;
      color: rgba(76,89,107,1);
      margin-top: 16px;
      margin-left: 30px;
      margin-bottom: 34px;
    }
    .extend_pic {
      width: 100%;
    }
  }
  .gif {
    width: 100%;
  }
  .img {
    width: 100%;
  }
}
a {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/chromeNew.vue